import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthenticationContext } from "@cloudmlm/cloudmlm-auth";
import _ from "lodash";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import {
  Box,
  Button,
  Card,
  Chip,
  Grid,
  Stack,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Alert,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CheckIcon from "@mui/icons-material/Check";
import { httpGet, httpPost } from "../../services/commonService";
import urlConstant from "../../constants/urlConstants";
import dataConstant from "../../constants/dataConstants";
import SnackState from "../../shared-components/snackbar/snackState";
import CommonSnackBar from "../../shared-components/snackbar/commonSnackbar";
import { messageConstant } from "../../constants/messageConstant";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import {selectUserDetail} from "../../redux/slice/userSlice";

const getNextProcessDate = () => {
  const today = moment();
  const currentYear = today.year();
  const currentMonth = today.month();

  const firstOfMonth = moment([currentYear, currentMonth, 1]);
  const fifteenthOfMonth = moment([currentYear, currentMonth, 15]);

  if (today.isBefore(firstOfMonth)) {
    return firstOfMonth.toDate();
  } else if (today.isBefore(fifteenthOfMonth)) {
    return fifteenthOfMonth.toDate();
  } else {
    return moment([currentYear, currentMonth + 1, 1]).toDate();
  }
};

const getCurrentDate = () => {
  return moment().toDate();
};

let isPaymentProfileCreated = false;
const ManageMembership = () => {
  const getLoggedUserDetails = useSelector(selectUserDetail);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const authenticationState = useContext(AuthenticationContext);
  const { Id } = useParams();
  const [snack, closeSnack, showSnackbar] = SnackState();
  const [smartShipInvoiceDet, setSmartShipInvoiceDet] = useState({
    nextProcessDate: getNextProcessDate(),
    taxAmount: 0.0,
    shippingAmount: 0.0,
    hiddenField: "",
    isUserPaymentProfileExsit: false,
  });
  const { bylder, consultant, retryMembership } = location.state || {
    bylder: false,
    consultant: false,
  };
  const [isDisableButtons, setIsDisableButtons] = useState(false);
  const [initialSelectedItem, setInitialSelectedItem] = useState(null);
  const [membershipChangeFlag, setMembershipChangeFlag] = useState(false);
  const [IsUserPaymentProfileExist, SetIsUserPaymentProfileExist] = useState(0);
  const [smartShipList, setSmartShipList] = useState([]);
  const [acctId, SetAcctId] = useState(0);
  const [selectedItem, setSelectedItem] = useState(null);
  const [retryMembershipforEdit, setRetryMembershipforEdit] = useState(false);
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [userLatestPackageTypeStatus, setUserLatestPackageTypeStatus] = useState("active");

  const methods = useForm({
    mode: "all",
    defaultValues: {
      nextProcessDate: null,
    },
  });
  const {
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = methods;

  const initializeUserLatestPackageTypeStatus = () => {
    setUserLatestPackageTypeStatus(getLoggedUserDetails?.PurchasePackageDetails?.LatestPackageTypeStatus?.toLowerCase());

    if (!Id) {
      const defaultDate = (getLoggedUserDetails?.PurchasePackageDetails?.LatestPackageTypeStatus?.toLowerCase() === "inactive") ? getCurrentDate() : getNextProcessDate();
      setValue("nextProcessDate", defaultDate);
      setSmartShipInvoiceDet((prevState) => ({
        ...prevState,
        nextProcessDate: defaultDate,
      }));
    }
  };

  useEffect(() => {
    getSmartShipList();
    initializeUserLatestPackageTypeStatus();
  }, []);

  const nextProcessDateValidator = (value) => {
    if (value === null) {
      return t("Memberships.PleaseSelect") + t("Memberships.next order date");
    }
    if (retryMembershipforEdit) {
      return true;
    }
    const currentDate = new Date(value);
    const getDay = currentDate.getDate();
    return !retryMembership && getDay !== 1 && getDay !== 15
      ? t("Memberships.PleaseSelect") + t("Memberships.next order date")
      : true;
  };

  const getSmartShipList = () => {
    const getSmartShipListURL = `${
      urlConstant.SmartShipInvoice.GetSmartShipList
    }?InvoiceId=${Id ?? 0}`;
    httpGet(
      getSmartShipListURL,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        if ( response?.Value?.Status === dataConstant.APIResponseStatus.Failure) {
          showSnackbar(response.Value.Message, "error");
          setTimeout(() => {
            navigate("/membership");
            setIsApiCalled(true);
          }, 2000);
        } else if (response?.Value?.Data) {
          setSmartShipList(response.Value.Data.ItemList);
          SetAcctId(response.Value.Data.AcctId);
          if (response.Value.Data.StrNextProcessDate) {
            setSmartShipInvoiceDet((prevState) => ({
              ...prevState,
              nextProcessDate: new Date(response.Value.Data.StrNextProcessDate),
            }));
            setValue(
              "nextProcessDate",
              new Date(response.Value.Data.StrNextProcessDate)
            );
          }
          SetIsUserPaymentProfileExist(
            response.Value.Data.IsUserPaymentProfileExsit
          );
          if (!response.Value.Data.IsUserPaymentProfileExsit) {
            const acceptURL = `${process.env.REACT_APP_ACCEPT_JS_URL}`;
            loadScript(acceptURL);
            window.responseHandlerHosted = responseHandlerHosted;
          }
          const selectedItemIndex = response.Value.Data.ItemList.findIndex(
            (item) => item.ItemQuantity === 1
          );
          if (selectedItemIndex !== -1) {
            setSelectedItem(selectedItemIndex);
            setInitialSelectedItem(selectedItemIndex);
          } else {
            if (!Id && response.Value.Data.ItemList.length === 1) {
              setSelectedItem(0);
              setInitialSelectedItem(0);
              const tempSmartShipList = [...response.Value.Data.ItemList];
              tempSmartShipList[0].ItemQuantity = 1;
              tempSmartShipList[0].totalAmount = tempSmartShipList[0].ItemPrice;
              setSmartShipList(tempSmartShipList);
            }
          }
          if (response.Value.Data.RetrySmartShipInvoiceID === true) {
            setRetryMembershipforEdit(true);
          }
          setIsApiCalled(true);
        } else if (
          response?.Value?.Message === messageConstant.InvalidAuthorizationPage
        ) {
          showSnackbar(response?.Value?.Message, "error");
          setTimeout(() => {
            navigate("/membership");
            setIsApiCalled(true);
          }, 2000);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const loadScript = (src) => {
    const tag = document.createElement("script");
    tag.src = src;
    document.body.appendChild(tag);
  };

  const responseHandlerHosted = (data) => {
    if (!isPaymentProfileCreated) {
      isPaymentProfileCreated = true;
      if (data && data.messages.resultCode === "Ok") {
        const model = {
          PaymentDetails: [
            {
              Token: data.opaqueData.dataValue,
              CCLast4Digit: data.encryptedCardData.cardNumber,
              ExpireDate: data.encryptedCardData.expDate,
            },
          ],
        };
        const createURL = urlConstant.PaymentProfile.CreatePaymentProfile;
        httpPost(
          createURL,
          model,
          true,
          true,
          authenticationState.accessToken,
          authenticationState.impersonateEmail
        )
          .then((response) => {
            isPaymentProfileCreated = false;
            if (response.Status === dataConstant.APIResponseStatus.Success) {
              showSnackbar(response?.description, "success");
              SetIsUserPaymentProfileExist(true);
            } else if (
              response.Status === dataConstant.APIResponseStatus.Failure
            ) {
              const acceptURL = `${process.env.REACT_APP_ACCEPT_JS_URL}`;
              loadScript(acceptURL);
              window.responseHandlerHosted = responseHandlerHosted;
              showSnackbar(response?.error, "error");
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (data && data.messages.resultCode === "Error") {
        let i = 0;
        let message = "";
        while (i < data.messages.message.length) {
          message = data.messages.message[i].text;
          i += 1;
        }
        if (message !== "") {
          showSnackbar(message, "error");
        }
      }
    }
  };

  const handleChange = (quantity, index) => {
    const tempQuantity = !quantity || quantity < 0 ? 0 : quantity;
    const tempSmartShipList = [...smartShipList];
    tempSmartShipList[index].ItemQuantity = tempQuantity;
    tempSmartShipList[index].totalAmount =
      tempSmartShipList[index].ItemPrice * tempQuantity;
    setSmartShipList(tempSmartShipList);

    const tempSmartShipInvoiceDet = smartShipInvoiceDet;
    tempSmartShipInvoiceDet.hiddenField = "value1";
    setSmartShipInvoiceDet(tempSmartShipInvoiceDet);
  };

  const handleCardClick = (item, index) => {
    if (selectedItem !== null) {
      handleChange(0, selectedItem);
    }
    handleChange(1, index);
    setSelectedItem(index);
    if (initialSelectedItem !== index) {
      setMembershipChangeFlag(true);
    } else {
      setMembershipChangeFlag(false);
    }
  };

  const getAllFeature = (description) => {
    const getAllDescription = _.split(description, " + ")?.filter(Boolean);
    return getAllDescription;
  };

  const disableDates = (date) => {
    // Case 1: Retry membership case → allow all dates 
    // Case 2: Inactive package status of account → enable all dates (both Add & edit)
    if ((retryMembership || retryMembershipforEdit) || userLatestPackageTypeStatus?.toLowerCase() === "inactive") {
      return false;
    }

    // Active package status of account with ID → only 1st & 15th are enabled
    if (userLatestPackageTypeStatus?.toLowerCase() === "active") {
      return !(date.getDate() === 1 || date.getDate() === 15);
    }
    // Default: disable
    return true;
  };

  const nextProcessDateChange = async (event) => {
    const value = Array.isArray(event) ? event[0] : event;
    setSmartShipInvoiceDet((prevState) => ({
      ...prevState,
      nextProcessDate: value,
    }));
    setValue("nextProcessDate", value);
  };

  const onSubmit = (event) => {
    if (!Id) createSmartShip(event.hiddenField === "UpdatePaymentInfoClicked");
    else editSmartShip(event.hiddenField === "UpdatePaymentInfoClicked");
  };

  const createSmartShip = (isPaymentInfoClicked) => {
    setIsDisableButtons(true);
    const tempSmartShipList = _.filter(smartShipList, (i) => {
      return i.ItemQuantity > 0;
    });
    if (tempSmartShipList.length > 0) {
      // Check for BYLD and Consultant conditions
      let byldCount = 0;
      let consultantCount = 0;

      tempSmartShipList.forEach((obj) => {
        if (bylder && obj.ItemName.includes("BYLD")) {
          byldCount += 1;
        }
        if (consultant && obj.ItemName.includes("Consultant")) {
          consultantCount += 1;
        }
      });

      if (byldCount > 0) {
        showSnackbar(t("Memberships.BYLDerLimit"), "error");
        setIsDisableButtons(false);
        return;
      }

      if (consultantCount > 0) {
        showSnackbar(t("Memberships.ConsultantLimit"), "error");
        setIsDisableButtons(false);
        return;
      }

      const model = {
        NextProcessDate: moment(smartShipInvoiceDet.nextProcessDate).format(
          dataConstant.DateFormatArray[2]
        ),
        AcctID: acctId,
        TaxAmount: smartShipInvoiceDet.taxAmount,
        ShippingAmount: smartShipInvoiceDet.shippingAmount,
        CallFrom: dataConstant.BackOfficeInvoice,
        SmartShipItemdetail: tempSmartShipList.map((obj) => {
          return {
            ItemID: obj.ItemId,
            ItemQuantity: obj.ItemQuantity,
            ItemName: obj.ItemName,
            ItemType: null,
          };
        }),
      };
      const createURL = urlConstant.SmartShipInvoice.CreateSmartShipInvoice;
      httpPost(
        createURL,
        model,
        true,
        true,
        authenticationState.accessToken,
        authenticationState.impersonateEmail
      )
        .then((response) => {
          if (response.Status === dataConstant.APIResponseStatus.Success) {
            showSnackbar(response.description, "success");
            setTimeout(() => {
              navigate("/membership");
              setIsDisableButtons(false);
            }, 1000);
          } else if (
            response.Status === dataConstant.APIResponseStatus.Failure
          ) {
            showSnackbar(response.error, "error");
            setIsDisableButtons(false);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      showSnackbar(
        messageConstant.MemberShipInvoice.InvalidMemberShipItem,
        "error"
      );
      setIsDisableButtons(false);
    }
  };

  const editSmartShip = (isPaymentInfoClicked) => {
    setIsDisableButtons(true);
    const tempSmartShipList = _.filter(smartShipList, (i) => {
      return i.ItemQuantity > 0;
    });

    if (tempSmartShipList.length <= 0) {
      showSnackbar(
        messageConstant.MemberShipInvoice.InvalidMemberShipItem,
        "error"
      );
      setIsDisableButtons(false);
      return;
    }

    // Check for BYLD and Consultant conditions
    let byldCount = 0;
    let consultantCount = 0;

    tempSmartShipList.forEach((obj) => {
      if (membershipChangeFlag) {
        if (bylder && consultant && obj.ItemName.includes("BYLD")) {
          byldCount += 1;
        }
        if (bylder && consultant && obj.ItemName.includes("Consultant")) {
          consultantCount += 1;
        }
      }
    });

    if (byldCount > 0) {
      showSnackbar(t("Memberships.BYLDerLimit"), "error");
      setIsDisableButtons(false);
      return;
    }

    if (consultantCount > 0) {
      showSnackbar(t("Memberships.ConsultantLimit"), "error");
      setIsDisableButtons(false);
      return;
    }

    const model = {
      Id,
      NextProcessDate: moment(smartShipInvoiceDet.nextProcessDate).format(
        dataConstant.DateFormatArray[2]
      ),
      SmartShipItemdetail: tempSmartShipList.map((obj) => {
        return {
          ItemID: obj.ItemId,
          ItemQuantity: obj.ItemQuantity,
          ItemName: obj.ItemName,
          ItemType: null,
        };
      }),
    };
    const editURL = urlConstant.SmartShipInvoice.EditSmartShipInvoice;
    httpPost(
      editURL,
      model,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        if (response.Status === dataConstant.APIResponseStatus.Success) {
          showSnackbar(response.description, "success");
          setTimeout(() => {
            navigate("/membership");
            setIsDisableButtons(false);
          }, 1000);
        } else if (response.Status === dataConstant.APIResponseStatus.Failure) {
          showSnackbar(response.error, "error");
          setIsDisableButtons(false);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <>
      <Box flexDirection={"column"} gap={2} display={"flex"}>
        <Typography color="secondary.light" variant="h4" fontWeight={600}>
          {t("My Account")}
        </Typography>
        {isApiCalled && (
          <Box width={"100%"}>
            <Card
              sx={(theme) => ({
                p: {
                  xs: "20px",
                  sm: "25px 30px",
                },
                background: theme.palette.background.cardGradient,
                border: "1px solid var(--headerbg)",
                borderRadius: "20px",
                height: "100%",
              })}
            >
              {!IsUserPaymentProfileExist && (
                <Stack gap={"10px"} sx={{ paddingBottom: "10px" }}>
                  <Alert
                    sx={(theme) => ({
                      background: theme.palette.common.errorbg,
                      color: theme.palette.common.errortext,
                    })}
                    variant="filled"
                    severity="info"
                  >
                    {t("Memberships.PaymentProfileNOTExits_Alert1")}
                  </Alert>
                  <Alert
                    sx={(theme) => ({
                      background: theme.palette.common.errorbg,
                      color: theme.palette.common.errortext,
                    })}
                    variant="filled"
                    severity="info"
                  >
                    {t("Memberships.PaymentProfileNOTExits_Alert2")}
                  </Alert>
                </Stack>
              )}
              <Typography color="secondary.light" variant="h4" fontWeight={600}>
                {t("Memberships.PageTitle")}
              </Typography>
              <Card
                className="hero-section"
                sx={(theme) => ({
                  p: {
                    xs: "20px",
                    sm: "25px 30px",
                  },
                  background: theme.palette.common.black,
                  borderRadius: "20px",
                  mt: "20px",
                })}
              >
                <form noValidate onSubmit={handleSubmit(onSubmit)}>
                  <Grid container spacing={2}>
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      justifyContent={"space-between"}
                      width={"100%"}
                      alignItems={{ xs: "stretch", sm: "center" }}
                      gap={"20px"}
                    >
                      <Stack direction={"column"}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: "12px",
                            color: "var(--secondary-text)",
                            mb: "4px",
                          }}
                          color={errors?.nextProcessDate?.message && "error"}
                        >
                          {t("Memberships.DateOfNextOrder")} <span>*</span>
                        </Typography>
                        <Controller
                          name="nextProcessDate"
                          control={control}
                          rules={{
                            required:
                              t("Memberships.PleaseSelect") +
                              t("Memberships.next order date"),
                            validate: nextProcessDateValidator,
                          }}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              className="cm-date-picker"
                              format="yyyy-MM-dd"
                              disablePast
                              shouldDisableDate={disableDates}
                              value={field.value || (!Id && userLatestPackageTypeStatus?.toLowerCase() === "Inactive" ? getCurrentDate() : smartShipInvoiceDet?.nextProcessDate)}
                              onChange={(date) => {
                                field.onChange(date);
                                nextProcessDateChange(date);
                              }}
                              sx={{
                                width: "100%",
                                "& .MuiPickersInputBase-root ": {
                                  backgroundColor: "var(--inputs)",
                                  color: "var(--black)",
                                  minHeight: "50px",
                                  borderRadius: "10px",
                                },
                                "& .MuiPickersSectionList-root": {
                                  padding: "13.5px 0",
                                },
                              }}
                            />
                          )}
                        />
                        {errors?.nextProcessDate?.message && (
                          <Typography color="error" variant="caption">
                            {errors.nextProcessDate.message}
                          </Typography>
                        )}
                      </Stack>
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        justifyContent="flex-end"
                        gap={"20px"}
                        width={{ xs: "100%", sm: "auto" }}
                      >
                        <Button
                          type="submit"
                          disabled={
                            isDisableButtons || !IsUserPaymentProfileExist
                          }
                          variant="contained"
                          color="secondary"
                        >
                          {t("Memberships.SaveMembership")}
                        </Button>
                        {!IsUserPaymentProfileExist && (
                          <Button
                            variant="contained"
                            type="button"
                            className="AcceptUI"
                            color="secondary"
                            data-billingaddressoptions='{"show":true, "required":true}'
                            data-apiloginid={
                              process.env.REACT_APP_AUTHNET_API_LOGIN_KEY
                            }
                            data-clientkey={
                              process.env.REACT_APP_AUTHNET_API_CLIENT_KEY
                            }
                            data-acceptuiformbtntxt={
                              messageConstant.Payment.SubmitFormTitle
                            }
                            data-acceptuiformheadertxt={
                              messageConstant.PaymentProfile
                                .AddPaymentProfileButtonTitle
                            }
                            data-paymentoptions='{"showCreditCard": true, "showBankAccount": false}'
                            data-responsehandler="responseHandlerHosted"
                          >
                            {t("Memberships.UpdatePaymentInfo")}
                          </Button>
                        )}
                      </Stack>
                    </Stack>
                  </Grid>
                  <Typography
                    color="secondary.light"
                    variant="h5"
                    fontWeight={600}
                    mt={"20px"}
                  >
                    {t("Memberships.BeforeProductShowingNotes")}
                  </Typography>
                  <Stack
                    gap={"20px"}
                    style={{ paddingTop: "20px" }}
                    width={"100%"}
                  >
                    <Grid container spacing={"20px"}>
                      {smartShipList?.length > 0 &&
                        smartShipList.map((item, index) => (
                          <Grid key={index} size={{ xs: 12, sm: 6 }}>
                            <Card
                              sx={(theme) => ({
                                background: theme.palette.secondary.lightest,
                                borderRadius: "20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                                flexDirection: "column",
                                height: "100%",
                                padding: "20px",
                                border:
                                  item.ItemQuantity === 1
                                    ? `2px solid ${theme.palette.primary.main}`
                                    : "none",
                              })}
                            >
                              <Stack gap={2} alignItems="center" width="100%">
                                <Chip
                                  sx={(theme) => ({
                                    background: theme.palette.secondary.light,
                                    borderRadius: "4px",
                                    color: theme.palette.common.black,
                                    fontWeight: 600,
                                    fontSize: "16px",
                                  })}
                                  label={item.ItemName}
                                />

                                <img
                                  src={item.ImagePath || "/icons/star.svg"}
                                  alt="Product"
                                  className="cm-star-image"
                                />

                                <Typography
                                  color="secondary.light"
                                  variant="h4"
                                  fontWeight={600}
                                >
                                  $
                                  {(item.ItemPrice).toFixed(
                                    dataConstant.TwoDigitConstValue
                                  )}
                                </Typography>

                                <Divider
                                  sx={(theme) => ({
                                    background: theme.palette.common.black,
                                    height: 2,
                                    width: "100%",
                                  })}
                                  variant="middle"
                                />

                                <List aria-label="features">
                                  {item.ItemDescription !== null &&
                                    item.ItemDescription !== "" &&
                                    getAllFeature(item.ItemDescription)?.map(
                                      (descriptionItem, indexDescription) => {
                                        return (
                                          <ListItem
                                            key={indexDescription}
                                            disablePadding
                                          >
                                            <ListItemIcon>
                                              <CheckIcon />
                                            </ListItemIcon>
                                            <ListItemText
                                              sx={(theme) => ({
                                                color:
                                                  theme.palette.secondary.main,
                                              })}
                                              primary={descriptionItem}
                                            />
                                          </ListItem>
                                        );
                                      }
                                    )}
                                </List>

                                <Button
                                  onClick={() => handleCardClick(item, index)}
                                  variant="contained"
                                  color="primary"
                                  sx={{ px: 3 }}
                                >
                                  {t("Common.Select")}
                                </Button>
                              </Stack>
                            </Card>
                          </Grid>
                        ))}
                    </Grid>
                  </Stack>
                </form>
              </Card>
            </Card>
            <Stack
              direction={"row"}
              justifyContent={{ xs: "center", sm: "flex-start" }}
              mt={2}
              gap={"20px"}
            >
              <Button
                type="button"
                onClick={() => navigate("/membership")}
                variant="outlined"
                color="primary"
                startIcon={<KeyboardBackspaceOutlinedIcon color="primary" />}
                sx={{ px: 3, border: "1px solid var(--headerbg)" }}
              >
                {" "}
                {t("Common.Back")}
              </Button>
            </Stack>
          </Box>
        )}
      </Box>
      <CommonSnackBar snackObj={snack} closeSnack={closeSnack} buttonProp />
    </>
  );
};
export default ManageMembership;